import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Frog(props: PresetArtProps) {
  return (
    <PresetFrame background="#4d7c0f" {...props}>
      <circle cx="21" cy="25" r="8" fill="#ffffff" />
      <circle cx="43" cy="25" r="8" fill="#ffffff" />
      <ellipse cx="32" cy="39" rx="19" ry="13" fill="#ffffff" />
      <circle cx="21" cy="25" r="3.5" fill="#1f2937" />
      <circle cx="43" cy="25" r="3.5" fill="#1f2937" />
      <path d="M22 41 Q32 49 42 41" fill="none" stroke="#1f2937" strokeWidth="3" strokeLinecap="round" />
    </PresetFrame>
  );
}
